import { render, staticRenderFns } from "./DistrictPriceModal.vue?vue&type=template&id=747ae1ce&scoped=true&"
import script from "./DistrictPriceModal.vue?vue&type=script&lang=js&"
export * from "./DistrictPriceModal.vue?vue&type=script&lang=js&"
import style0 from "./DistrictPriceModal.vue?vue&type=style&index=0&id=747ae1ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747ae1ce",
  null
  
)

export default component.exports